import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6d01,
  properties: ["read", "write", "notify"],
};
export function generateMockCSTNofifyData(): DomianControl.CSTNotifyData {
  const data = getMockDataByKeys([
    // 左前轮实际制动力
    "UIRx_WhlBrkTqAct_FL_BCh1",
    // 右前轮实际制动力
    "UIRx_WhlBrkTqAct_FR_BCh1",
    // 左后轮实际制动力
    "UIRx_WhlBrkTqAct_RL_BCh1",
    // 右后轮实际制动力
    "UIRx_WhlBrkTqAct_RR_BCh1",
    // 驾驶员制动意图
    "UIRx_DrvrReqTrgtFxBrk_Bch1",
    // 车辆静止信号
    "UIRx_VehSdsl" ,
    // 纵向减速度
    "UIRx_ACULongdAcc",
    // 车辆俯仰角，VDM通过四个悬架高度信号计算
    "UIRx_PitchAng",
    // 车辆速度
    "UIRx_VehSpd",
  ]);
  return data;
}
